import { BsFillChatLeftTextFill, BsFillSendFill } from 'react-icons/bs'
import { FaBook } from 'react-icons/fa'
import { BiSolidUserCircle } from 'react-icons/bi'
import { Card, Button, Form, Badge, Row, Col, Placeholder, Modal } from "react-bootstrap";
import { useEffect, useRef, useState } from 'react';
import Linkify from 'linkify-react';
import StyleComment from '../../util/StyleComment';
import { useSelector, useDispatch } from 'react-redux';
import { useNavigate } from 'react-router-dom';
import { selectWindowWidth } from "../../features/windowWidth/windowWidth";
import { selectLogin } from '../../features/login/login'
import { updateEditID } from '../../features/editID/editID';
import { update } from '../../features/searchKeyword/searchKeyword';
import { selectName } from '../../features/name/name';
import useIsVisible from '../../hooks/useIsVisible';
import ReplyItem from '../ReplyItem/ReplyItem';
import './CommentItem.css';

const fetch_content_url = process.env.REACT_APP_API_URL + '/comments/comment';
const reply_url = process.env.REACT_APP_API_URL + '/comments/reply';
const delete_url = process.env.REACT_APP_API_URL + '/comments/me';
const specialChar = ['⊕', '▲', '★', '￡', '◆', '▼', '￠', '￥', '＆誰適合修這門課＆'];
const spaceRegex = /^[\s\t\u200B-\u200D\u202F\u205F\u3000]*$/;
const imageLinkRegex = /^#image\[[^\]]*\bhttps:\/\/i\.imgur\.com\/[^\]]*\]$/;
const extractLinkRegex = /#image\[(https:\/\/[^\]]*)\]/g;
const linkifyOptions = { target: '_blank', rel: 'noopener noreferrer' };

const CommentItem = (props) => {
  const [content, setContent] = useState("");
  const [styledComment, setStyledComment] = useState([]);
  const [displayFullContent, setDisplayFullContent] = useState(false);
  const [reply, setReply] = useState([]);
  const [lastYpos, setLastYpos] = useState(0);
  const [newReply, setNewReply] = useState('');
  const [loading, setLoading] = useState(false);
  const [moreLoading, setMoreLoading] = useState(false);
  const [editingReply, setEditingReply] = useState(false);
  const [showDeleteComment, setShowDeleteComment] = useState(false);
  const [authorID, setAuthorID] = useState();
  const [displayReply, setDisplayReply] = useState(false);
  const windowWidth = useSelector(selectWindowWidth);
  const login = useSelector(selectLogin);
  const name = useSelector(selectName);
  const visibleRef = useRef();
  const dispatch = useDispatch();
  const navigate = useNavigate();

  const isVisible = useIsVisible(visibleRef);

  useEffect(() => {
    if (isVisible) {
      getContent(props.ele.id);
    }
  }, [isVisible])

  const getContent = async (id) => {
    setLoading(true);
    const response = await fetch(`${fetch_content_url}?id=${id}`).then((res) => {
      return res.json();
    })
    setAuthorID(response.user_id);
    let fullContent = response.content;
    const styledStr = StyleComment(fullContent);
    setStyledComment(styledStr.split('\n').filter(str => str !== ''));
    if (windowWidth >= 600) {
      if (fullContent.length > 60) {
        fullContent = fullContent.slice(0, 60) + '......';
      }
    } else {
      if (fullContent.length > 40) {
        fullContent = fullContent.slice(0, 40) + '......';
      }
    }
    setContent(fullContent);
    setLoading(false);
  }

  const handleShowMore = async (e) => {
    e.preventDefault();

    if (displayFullContent === false) {
      if (reply.length === 0) {
        setMoreLoading(true);
        const replyRes = await fetch(`${reply_url}?id=${props.ele.id}`)
          .then((res) => {
            if (res.ok) return res.json();
            else return [];
          })
        setReply(replyRes);
        setMoreLoading(false);
      }
      setLastYpos(window.scrollY);
    } else {
      if (editingReply) setEditingReply(false);
      window.scrollTo({
        top: lastYpos,
        behavior: 'instant'
      })
    }

    setDisplayFullContent(!displayFullContent);
  }

  const handlePostReply = async () => {
    if (newReply.length === 0) {
      return;
    }
    if (spaceRegex.test(newReply)) {
      alert('請輸入有意義的留言！');
      return;
    }
    if (newReply === '[這則留言已被刪除]') {
      alert('無效留言，請輸入其他文字。');
      return;
    }
    await fetch(reply_url, {
      method: 'POST',
      credentials: 'include',
      headers: {
        'Content-Type': 'application/json'
      },
      body: JSON.stringify({ id: props.ele.id, content: newReply })
    }).then(async () => {
      refetchReply();
      setNewReply('');
      setDisplayReply(true);
    })
  }

  const handleEdit = (e) => {
    e.preventDefault();
    dispatch(updateEditID(props.ele.id));
    navigate('/new');
  }

  const handleClickDelete = (e) => {
    e.preventDefault();
    setShowDeleteComment(true);
  }

  const handleDeleteComment = async (e) => {
    e.preventDefault();
    await fetch(`${delete_url}?id=${props.ele.id}`, {
      method: 'DELETE',
      credentials: 'include'
    })
    setShowDeleteComment(false);
    window.location.reload();
  }

  const refetchReply = async () => {
    const replyRes = await fetch(`${reply_url}?id=${props.ele.id}`).then((res) => {
      if (res.ok) return res.json();
      else return [];
    })
    setReply(replyRes);
  }

  const handleSubmit = (e) => {
    e.preventDefault();
    handlePostReply();
  }

  const getLink = (str) => {
    while (true) {
      const matches = extractLinkRegex.exec(str);
      if (matches !== null) return matches[1];
    }
  }

  return (
    <div
      bg='light'
      text='dark'
      ref={visibleRef}
      className="card mb-3 border-0"
      style={{ height: 'max-content', width: windowWidth < 900 ? '90%' : '80%', margin: 'auto', color: '#4b3615', fontFamily: 'Noto Sans TC' }}
    >
      <Modal show={showDeleteComment} onHide={() => setShowDeleteComment(false)}>
        <Modal.Header closeButton>
          <Modal.Title>確認刪除</Modal.Title>
        </Modal.Header>
        <Modal.Body>確認要刪除心得嗎？</Modal.Body>
        <Modal.Footer>
          <Button variant="secondary" onClick={() => setShowDeleteComment(false)}>
            取消
          </Button>
          <Button variant="danger" onClick={handleDeleteComment}>
            確認
          </Button>
        </Modal.Footer>
      </Modal>
      <Card.Title
        style={{ marginTop: '20px', marginLeft: '20px' }}
      >
        <p style={{ fontSize: windowWidth >= 600 ? '18px' : '16px' }} className='d-flex align-items-center'>
          <BiSolidUserCircle size={windowWidth >= 600 ? 25 : 22} color='#4b3615' style={{ marginRight: '10px' }} />
          匿名
        </p>
        <FaBook
          size={windowWidth >= 600 ? 20 : 18}
          color='#4b3615'
          style={{ marginBottom: windowWidth >= 600 ? '5px' : '2px', marginRight: '10px' }}
        />
        <span style={{ fontSize: windowWidth >= 600 ? '20px' : '18px' }}>{props.ele.title}</span>
        {windowWidth < 600 && <br />}
        <Badge
          bg='success'
          pill
          className={windowWidth < 600 ? 'mt-3' : 'ms-2'}
          style={{
            paddingBottom: windowWidth >= 600 ? '7px' : '5px',
            position: 'relative',
            bottom: '2px',
            fontSize: windowWidth >= 600 ? '14px' : '12px'
          }}
          onClick={() => dispatch(update(props.ele.name))}
        >
          &nbsp;{props.ele.name}&nbsp;
        </Badge>
        <Badge
          bg='warning'
          pill
          text='dark'
          className={'ms-2'}
          style={{
            paddingBottom: windowWidth >= 600 ? '7px' : '5px',
            position: 'relative',
            bottom: '2px',
            fontSize: windowWidth >= 600 ? '14px' : '12px'
          }}
          onClick={() => dispatch(update(props.ele.ch_name))}
        >
          &nbsp;{props.ele.ch_name}&nbsp;
        </Badge>
      </Card.Title>
      {loading ?
        <Placeholder
          as={Card.Text}
          animation="glow"
          style={{ marginLeft: '20px', marginBottom: '20px', marginRight: '20px' }}
        >
          <Placeholder xs={12} />
        </Placeholder>
        :
        <Card.Text
          style={{ marginLeft: '22px', marginBottom: '20px', marginRight: '20px' }}
        >
          {displayFullContent ? styledComment.map((line, index) => {
            if ((specialChar.some(char => line.includes(char)) && line.length < 12)) {
              return (
                <span
                  key={index}
                  style={{ fontWeight: '500', fontSize: windowWidth >= 600 ? '20px' : '18px', fontFamily: 'Noto Sans TC' }}
                >
                  {index > 0 && <br />}
                  {line}<br />
                </span>
              );
            } else if (imageLinkRegex.test(line)) {
              return <img src={getLink(line)} alt='user-uploaded' style={{ width: '70%' }} className='mt-2 mb-2' />
            } else {
              return (<span key={index} style={{ fontSize: windowWidth >= 600 ? '18px' : '16px', fontFamily: 'Noto Sans TC' }}><Linkify options={linkifyOptions}>{line}</Linkify><br /></span>);
            }
          }) : <Linkify options={linkifyOptions}>{content}</Linkify>}
        </Card.Text>
      }

      {displayFullContent &&
        (moreLoading ?
          <Placeholder
            as={Card.Text}
            animation="glow"
            style={{ marginLeft: '20px', marginBottom: '20px', marginRight: '20px' }}
          >
            <Placeholder xs={1} />
            <Placeholder xs={12} />
          </Placeholder>
          :
          <Card.Text style={{ marginLeft: '22px', marginBottom: '20px', marginRight: '20px' }}>
            {reply.length > 0 ?
              <>
                <BsFillChatLeftTextFill size={20} color='#4b3615' style={{ marginRight: '10px' }} />
                <span className='check-reply' onClick={() => setDisplayReply(!displayReply)}>
                  {displayReply ? '隱藏' : '查看'} {reply.length} 則留言
                </span>
              </>
              :
              <>
                <BsFillChatLeftTextFill size={20} color='#4b3615' style={{ marginRight: '10px' }} />
                沒有留言
              </>
            }
            {displayReply && reply.map((ele, id) => (
              <ReplyItem ele={ele} key={id} refetchReply={refetchReply} authorID={authorID} />
            ))}
            {login &&
              <Row className='mt-3'>
                {windowWidth > 768 &&
                  <Col xs='auto' style={{ color: 'gray' }} className='d-flex align-items-center'>
                    <BiSolidUserCircle size={20} color='#4b3615' className='me-1' />
                    {name}
                  </Col>
                }
                <Col xs={12} md={9}>
                  <Form className='d-flex align-items-center' onSubmit={handleSubmit}>
                    <Form.Control
                      rows={1}
                      onChange={(e) => setNewReply(e.target.value)}
                      placeholder='說點什麼...'
                      value={newReply}
                      className='me-4'
                    />
                    <BsFillSendFill
                      onClick={handlePostReply}
                      type='submit'
                      size={20}
                      className='post-icon'
                    />
                  </Form>
                </Col>
              </Row>
            }
          </Card.Text>
        )
      }
      <Row>
        <Button
          size='sm'
          as={Col}
          xs='auto'
          variant="secondary"
          className='mb-3'
          style={{ marginLeft: '32px', width: 'fit-content' }}
          onClick={handleShowMore}
        >
          {displayFullContent ? '顯示更少' : '顯示更多'}
        </Button>
        {props.variant === 'my-comment' &&
          <>
            <Button
              size='sm'
              as={Col}
              xs='auto'
              variant="success"
              className='mb-3 ms-3'
              style={{ width: 'fit-content' }}
              onClick={handleEdit}
            >
              編輯
            </Button>
            <Button
              size='sm'
              as={Col}
              xs='auto'
              variant="danger"
              className='mb-3 ms-3'
              style={{ width: 'fit-content' }}
              onClick={handleClickDelete}
            >
              刪除
            </Button>
          </>
        }
      </Row>
    </div>
  )
}

export default CommentItem;